/** Local YYYY-MM-DD (no UTC shift). */
export function formatDateLocal(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function addDaysLocal(date: Date, days: number): Date {
  const next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  next.setDate(next.getDate() + days);
  return next;
}

/** Monday 00:00 local of the week containing `date`. */
export function startOfWeekMonday(date: Date): Date {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const jsDay = d.getDay(); // 0=Sun … 6=Sat
  const dow = jsDay === 0 ? 7 : jsDay; // Mon=1 … Sun=7
  d.setDate(d.getDate() - (dow - 1));
  return d;
}

/** Sunday 00:00 local of the week containing `date`. */
export function endOfWeekSunday(date: Date): Date {
  return addDaysLocal(startOfWeekMonday(date), 6);
}

export function weekMondayContaining(date: Date): Date {
  return startOfWeekMonday(date);
}

/**
 * Monday of week containing the 1st of the month through
 * Sunday of week containing the last day of the month.
 */
export function monthGridRange(selectedMonth: Date): { rangeStart: Date; rangeEnd: Date } {
  const year = selectedMonth.getFullYear();
  const month = selectedMonth.getMonth();
  const monthStart = new Date(year, month, 1);
  const monthEnd = new Date(year, month + 1, 0);
  return {
    rangeStart: startOfWeekMonday(monthStart),
    rangeEnd: endOfWeekSunday(monthEnd),
  };
}

/** Inclusive list of local calendar days from start through end. */
export function eachLocalDay(start: Date, end: Date): Date[] {
  const days: Date[] = [];
  let cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endKey = formatDateLocal(end);
  while (formatDateLocal(cursor) <= endKey) {
    days.push(new Date(cursor.getFullYear(), cursor.getMonth(), cursor.getDate()));
    cursor = addDaysLocal(cursor, 1);
  }
  return days;
}
